module.exports = __webpack_public_path__ + "9d9f9f9efc93a2c294500c2cb99760cb.gif";